// URL-driven prefilters so Dashboard cards can deep-link into filtered lists.
const OVERDUE_STATUSES = ["Delinquent", "Late", "Unpaid", "Partial"];

export function readPrefilter(sp) {
  const csv = (k) => (sp.get(k) ? sp.get(k).split(",").map((x) => x.trim()).filter(Boolean) : null);
  return {
    status: csv("status"),
    not_status: csv("not_status"),
    overdue: sp.get("overdue") === "1",
    dueField: sp.get("dueField") || null,
    dueWithin: sp.get("dueWithin") ? Number(sp.get("dueWithin")) : null,
    label: sp.get("label") || null,
  };
}

export function hasPrefilter(pf) {
  return !!(pf.status || pf.not_status || pf.overdue || (pf.dueField && pf.dueWithin));
}

export function applyPrefilter(items, pf) {
  if (!hasPrefilter(pf)) return items;
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  const horizon = pf.dueWithin ? new Date(now.getTime() + pf.dueWithin * 86400000) : null;
  return items.filter((it) => {
    if (pf.status && !pf.status.includes(it.status)) return false;
    if (pf.not_status && pf.not_status.includes(it.status)) return false;
    if (pf.overdue) {
      const od = Number(it.outstanding || 0) > 0 || OVERDUE_STATUSES.includes(it.status);
      if (!od) return false;
    }
    if (pf.dueField && horizon) {
      const raw = it[pf.dueField];
      if (!raw) return false;
      const d = new Date(String(raw).slice(0, 10));
      if (isNaN(d.getTime()) || d > horizon) return false;
    }
    return true;
  });
}
